<template>
    <div id="wrap">
        <header id="header"
            :class="{ on: state.isMenuActive }">
            <div class="inner">
                <h1 id="logo"><a href="/main.html" title="메인으로 이동"><span class="text_hidden">한국토지신탁</span></a></h1>

                <nav id="gnb">
                    <MenuNavigation
                        :onSideButtonClick="eventHandler.onSideButtonClick"/>
                </nav>

                <button type="button" title="메뉴" id="menuToggle" @click="state.isMenuActive = state.isMenuActive ? false : true"><span></span><span></span><span></span></button>
            </div>
        </header>

        <div id="mVisu">
            <div class="txt-box inner">
                <p class="tit">Challenge for the Innovation</p>
                <p class="txt">창의적 사고와 도전하는 열정을 가진 인재는 <br class="mo_br">한국토지신탁의 백년대계를 이끌어갈 가장 중요한 자산입니다</p>
            </div>
            <ul class="quick-box inner">
                <li><a href="/recruit/careers">
                    <p>채용공고</p>
                    <span>Recruit</span>
                </a></li>
                <li><a href="/recruit/always-recruite">
                    <p>상시채용</p>
                    <span>regular Recruit</span>
                </a></li>  
                <li><a href="/information/report">
                    <p>지원서 조회/수정</p>
                    <span>application</span>
                </a></li>
                <li><a href="/information/confirm-notice">
                    <p>합격여부 조회</p>
                    <span>inquiry</span>
                </a></li>
            </ul>
        </div>

        <div id="mLatest" class="inner">
            <div class="main-title">
                <span>Latest Recruit</span>
                <h2>최신 채용공고</h2>
                <a href="/recruit/careers" title="더보기" class="more-btn"><span class="text_hidden" @click="eventHandler.MoreClick()">더보기</span></a>
            </div>
            <ul class="list-box">
                <li v-for="recentItems in state.recentList" v-bind:key="recentItems">
                    <a href="javascript:;">
                        <span v-if="recentItems.CodeVal==='CD021001'" class="cate case1">신입</span>
                        <span v-if="recentItems.CodeVal==='CD021002'" class="cate case2">경력</span>
                        <span v-if="recentItems.CodeVal==='CD021003'" class="cate case3">상시</span>
                        <p class="subject" @click="eventHandler.onRowClick(recentItems)">{{recentItems.Title}}</p>
                        <span class="date">{{recentItems.CreateDate}}</span> 
                    </a>
                </li>
            </ul>
        </div>

        <div id="mLeadership" class="inner">
            <div>
                <dl>
                    <dt>Pioneer Full of Leadership</dt>
                    <dd>한국토지신탁은 꿈과 열정을 가지고 <br class="mo_br">세계 최고에 도전하는 사람을 기다립니다.</dd>
                </dl>
                <a href="/company/talent" title="한국토지신탁 인재상" class="koreit-btn1">한국토지신탁 인재상</a>
            </div>
        </div>

        <div id="mFaq" class="inner">
            <div class="main-title">
                <span>FAQ</span>
                <h2>자주하는 질문</h2>
            </div>
            <ul class="list-box">

                <li v-for="(FAQItems, index) in state.FAQList" v-bind:key="FAQItems">
                    <a href="#" class="faq-question">
                        <span class="num">{{ index +1 }}</span>
                        <span class="subject">{{FAQItems.Title}}</span>
                    </a>
                    <div class="faq-answer">
                        <span v-html="FAQItems.Content"></span>
                    </div>
                </li>
            </ul>
        </div>

        <!-- 컨텐츠 -->
        <router-view />
        
        <!-- 푸터 영역 -->
        <Footer/>
    </div>
</template>
<script>
import MenuNavigation from '@/components/MenuNavigation.vue';
import { reactive, ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { onMounted } from '@vue/runtime-core';
import { useRoute, useRouter } from 'vue-router';
import router from '@/router';
import { menuDataSource } from '@/modules/menu-management.js';
import { careers } from '@/modules/recruit/careers.js';
import { common } from '@/modules/common.js';
import Footer from '@/components/Footer.vue';
export default {
    components: {
        MenuNavigation,
        Footer,
    },
    setup() {

        // 라우트
        const route = useRoute();

        // 스토어
        const store = useStore();

        // state(변수)
        const state = reactive({

            recentList : [],
            FAQList : [],

            // 상단 메뉴영역 active 여부
            isMenuActive: false,

        });
        
        // 이벤트 핸들러
        const eventHandler = {

            // 최상단으로 스크롤 이동 버튼 클릭 이벤트 처리
            onTopScrollClick: () => {

                window.scrollTo({ top: 0, behavior: "smooth" }); 
            },

            onRowClick: (e) => {

                //router.push({ name: 'CareersView', query: {Seq : e.Seq} });
                location.href = `/recruit/careers-view?Seq=${e.Seq}`;
            },
            
            MoreClick: () => {
                router.push({ name: 'careers', query: q });
                
            },

            /**
             * 모바일버전 뎁스 메뉴 화살표 클릭 이벤트 처리
             * @param {any} event
             */
             onSideButtonClick: (event) => {

                event.target.parentNode.classList.toggle('on');
            },
        }

        // 메소드
        const methods = {

            // 최신 채용공고 가져오기
            getRecruitList: () => {
                let objArr = null;
                objArr = {
                    "SystCode": "ADM"
                    , "BoardCategory": "RECCM001"
                    , "Title": ""
                    , "Content": ""
                    , "UseYn": "Y"
                    , "UserName": ""
                    , "UserNo": ""
                    , "CodeVal": ""
                    , "CurPage": 1
                    , "ListSize": 5
                    , "ExpiredDt": ""
                    , "ExcludeCodeVal": ""
                }

                objArr = !!objArr ? JSON.stringify(objArr) : null;
                careers.getRecruitNotice(objArr).then(field => {
                    state.recentList = field.Table.rows;
                }).finally(() => {

                });
            },
            
            // 자주하는 질문 가져오기
            getFAQList: () => {
                let objArr = null;
                objArr = {
                    "SystCode": "ADM"
                    , "BoardCategory": "RECCM003"
                    , "Title": ""
                    , "Content": ""
                    , "UseYn": "Y"
                    , "UserName": ""
                    , "UserNo": ""
                    , "CodeVal": ""
                    , "CurPage": 1
                    , "ListSize": 5
                    , "ExpiredDt": ""
                    , "ExcludeCodeVal": null
                }

                objArr = !!objArr ? JSON.stringify(objArr) : null;
                careers.getRecruitNotice(objArr).then(field => {
                    state.FAQList = field.Table.rows;
                }).finally(() => {

                    // FAQ 클릭 이벤트
                    const mFaqBtn = document.querySelectorAll("#mFaq .list-box .faq-question");
                    mFaqBtn.forEach((v)=>{
                        v.onclick = function(){
                            v.classList.toggle("on")

                            return false;
                        }
                    })
                });
            }
        }

        // Dom 객체 이후
        onMounted(() => {

            // 스크롤 이벤트 설정
            document.addEventListener('scroll', () => {

                const headerElement = document.getElementById("header");

                if (document.documentElement.scrollTop > 0) {

                    if (!headerElement.classList.contains('scroll-on')) headerElement.classList.add('scroll-on');
                }
                else headerElement.classList.remove('scroll-on');
            });

            // 최신 채용공고 가져오기
            methods.getRecruitList();

            // 자주하는 질문 가져오기
            methods.getFAQList();
            
            //세션스토리지 초기화
            sessionStorage.clear();
        });

        return {
            state,
            store,
            eventHandler,
            methods,
            router,
            common,
        }
    },
}
</script>